/**
 * Tabela de telas. Uma linha por tela (append-only). Caminhos em português, iguais aos links do bot.
 */
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AccountPage } from '../features/account/AccountPage';
import { AlertsPage } from '../features/alerts/AlertsPage';
import { LoginPage, SignupPage } from '../features/auth/AuthPages';
import { GuestOnly, RequireAuth } from '../features/auth/RequireAuth';
import { NewRoutePage } from '../features/routes/NewRoutePage';
import { RoutePage } from '../features/routes/RoutePage';
import { RoutesPage } from '../features/routes/RoutesPage';
import { TripPage } from '../features/trips/TripPage';
import { TripsPage } from '../features/trips/TripsPage';

const guest = (el: JSX.Element) => <GuestOnly>{el}</GuestOnly>;
const auth = (el: JSX.Element) => <RequireAuth>{el}</RequireAuth>;

export const router = createBrowserRouter([
  { path: '/entrar', element: guest(<LoginPage />) },
  { path: '/cadastro', element: guest(<SignupPage />) },
  { path: '/', element: auth(<RoutesPage />) },
  { path: '/rotas/nova', element: auth(<NewRoutePage />) },
  { path: '/rotas/:id', element: auth(<RoutePage />) },
  { path: '/viagens', element: auth(<TripsPage />) },
  { path: '/viagens/:id', element: auth(<TripPage />) },
  { path: '/alertas', element: auth(<AlertsPage />) },
  { path: '/conta', element: auth(<AccountPage />) },
  { path: '*', element: <Navigate to="/" replace /> },
]);
